(() => {
  const desktop = window.matchMedia('(min-width: 1024px)');

  function placeNutrition(root) {
    const block = root.querySelector('[data-klein-nutrition-block]');
    const target = root.querySelector('[data-klein-nutrition-target]');
    if (!block || !target) return;

    if (!block._kleinOrigin) {
      const marker = document.createComment('klein-nutrition-origin');
      block.parentNode.insertBefore(marker, block);
      block._kleinOrigin = marker;
    }

    if (desktop.matches) {
      target.appendChild(block);
    } else {
      block._kleinOrigin.parentNode.insertBefore(block, block._kleinOrigin.nextSibling);
    }
  }

  function update() {
    document.querySelectorAll('[data-js-product-component]').forEach(placeNutrition);
  }

  document.addEventListener('DOMContentLoaded', update);
  document.addEventListener('shopify:section:load', update);
  desktop.addEventListener('change', update);
})();
